import Icon from "components/AppIcon";
import Image from "components/AppImage";
import Header from "components/ui/Header"
import Sidebar from "components/ui/Sidebar";
import Button from "components/ui/Button";
import { useState } from "react";
import { Navigate } from "react-router-dom";

const Fields = ({ fieldName, datefield, fieldType = "text", user, setUser, textarea, isfile }) => {
    if (textarea) {
        return (
            <div className="my-4 flex items-center gap-4">
                <span className="text-sm text-text-secondary w-20">{fieldName}</span>
                <textarea
                    value={user[datefield]}
                    onChange={(e) =>
                        setUser((prev) => ({ ...prev, [datefield]: e.target.value }))
                    }
                    rows="5"
                    className="px-3 py-1 w-80 resize-none border border-border rounded text-sm focus:ring-2 focus:ring-border-focus focus:border-transparent"
                />
            </div>
        );
    }

    return (
        <div className="my-4 flex items-center gap-4">
            <span className="text-sm w-20 text-text-secondary">{fieldName}</span>
            <input
                type={fieldType}
                {...(!isfile && { value: user[datefield] })}
                onChange={(e) => {
                    if (isfile) {
                        setUser((prev) => ({ ...prev, [datefield]: e.target.files[0] }));
                    } else {
                        setUser((prev) => ({ ...prev, [datefield]: e.target.value }));
                    }
                }}
                accept={isfile ? "image/*" : undefined}
                className="px-3 py-1 w-80 border border-border rounded text-sm focus:ring-2 focus:ring-border-focus focus:border-transparent"
            />
        </div>
    );
};


const ProfileSettings = () => {
    const [sidebarCollapsed, setSidebarCollapsed] = useState(true);
    const [activeTab, setActiveTab] = useState('contact-information');
    const [current_password, setCurrentPassword] = useState("")
    const [new_password, setNewPassword] = useState("")
    const [confirmpassword, setConfirmPassword] = useState("")
    const [profileLoading, setProfileLoading] = useState(false)
    const [passwordLoading, setPasswordLoading] = useState(false)
    const token = localStorage.getItem('token');
    if (!token) {
        return <Navigate to="/admin" replace />
    }
    const [user, setUser] = useState(() => {
        try {
            return JSON.parse(localStorage.getItem('user'))
        } catch (error) {
            return null
        }
    });
    const toggleSidebar = () => {
        setSidebarCollapsed(!sidebarCollapsed);
    };
    const tabs = [
        { id: 'contact-information', label: 'Contact Information', icon: 'User' },
        { id: 'security', label: 'Profile Credentials', icon: 'Shield' },
        { id: 'password', label: 'Password Update', icon: 'KeyRound' },
    ];

    const handleSubmit = async () => {
        if (profileLoading) return;
        const formData = new FormData();

        const editableFields = [
            "email",
            "company_name",
            "phone",
            "gst_number",
            "address",
            "logo"
        ];

        editableFields.forEach((key) => {
            if (user[key] !== undefined) {
                formData.append(key, user[key])
            }
        })

        try {
            setProfileLoading(true)
            const res = await fetch(`${import.meta.env.VITE_APP_ADMINURL}/api/user-data/${user.id}`, {
                method: 'PUT',
                body: formData, // no Content-Type, browser sets it
            });

            if (!res.ok) {
                throw new Error("Failed to update user")
            }
            const updatedUser = await res.json()
            localStorage.setItem('user', JSON.stringify(updatedUser))
            setUser(updatedUser)
        } catch (error) {

        } finally {
            setProfileLoading(false)
        }

    };

    const handlechangepassword = async (e) => {
        e.preventDefault()
        if (passwordLoading) return;
        if (new_password === confirmpassword) {
            try {
                setPasswordLoading(true)
                const response = await fetch(`${import.meta.env.VITE_APP_ADMINURL}/api/changepassword/${user.id}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                    body: JSON.stringify({
                        current_password,
                        new_password
                    })
                })
                // console.log(response)
                if(response.ok){
                    setNewPassword("")
                    setCurrentPassword("")
                    setConfirmPassword("")
                    alert("Password Update Successfully")
                }
            } finally {
                setPasswordLoading(false)
            }
            return
        }
        // console.log("password miss match")
        return

    }


    return (
        <div className="min-h-screen bg-background">
            <Header
                user={user}
                onMenuToggle={toggleSidebar}
                sidebarCollapsed={sidebarCollapsed}
            />
            <Sidebar
                collapsed={sidebarCollapsed}
                onToggle={toggleSidebar}
                userRole={user.role}
            />
            <main className={`pt-header-height nav-transition ${sidebarCollapsed ? 'lg:pl-sidebar-collapsed' : 'lg:pl-sidebar-width'} `}>
                <div className="p-6">
                    {/* Page Header */}
                    <div className="mb-8">
                        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between">
                            <div>
                                <h1 className="text-3xl font-heading font-bold text-text-primary mb-2">
                                    Profile Settings
                                </h1>
                                <p className="text-text-secondary">
                                    Welcome {user.company_name}, Edit your profile here
                                </p>
                            </div>
                        </div>
                    </div>
                    {/* hero */}
                    <div className="bg-surface border border-boder rounded-lg p-4">
                        <nav className="flex gap-4">
                            {tabs.map((tab) => (
                                <button
                                    key={tab.id}
                                    onClick={() => setActiveTab(tab.id)}
                                    className={`flex grow items-center justify-center space-x-2 py-4 border-b-2 font-medium text-sm nav-transition ${activeTab === tab.id
                                        ? 'border-primary text-primary' : 'border-transparent text-text-secondary hover:text-text-primary'
                                        }`}
                                >
                                    <Icon name={tab.icon} size={16} color="currentColor" />
                                    <span>{tab.label}</span>
                                </button>
                            ))}
                        </nav>
                        <div className="p-6" >
                            {activeTab === 'contact-information' && (
                                <div>
                                    <h5>Contact Information</h5>
                                    <Fields fieldName="Phone:" fieldType="tel" datefield="phone" user={user} setUser={setUser} />
                                    <Fields fieldName="GST:" fieldType="text" datefield="gst_number" user={user} setUser={setUser} />
                                    <Fields fieldName="Address:" textarea fieldType="text" datefield="address" user={user} setUser={setUser} />
                                </div>
                            )}
                            {activeTab === 'security' && (
                                <div>
                                    <h5>Profile Credentials</h5>
                                    <div className="relative inline-block w-20 h-20">
                                        <Image
                                            src={user.logoPreview || `${import.meta.env.VITE_APP_ADMINURL}/${user.logo}`}
                                            alt="Logo Here"
                                            className="w-20 h-20 object-contain rounded border"
                                        />
                                        {/* Pencil icon overlay */}
                                        <button
                                            type="button"
                                            onClick={() => document.getElementById("logoUpload").click()}
                                            className="absolute bottom-1 right-1 bg-white p-1 rounded-full shadow hover:bg-gray-100"
                                        >
                                            <Icon name="Pencil" size={14} color="black" />
                                        </button>
                                        {/* Hidden file input */}
                                        <input
                                            type="file"
                                            id="logoUpload"
                                            className="hidden"
                                            onChange={(e) => {
                                                if (e.target.files[0]) {
                                                    const file = e.target.files[0];
                                                    setUser((prev) => ({
                                                        ...prev,
                                                        logo: file,
                                                        logoPreview: URL.createObjectURL(file), // preview
                                                    }));
                                                }
                                            }}

                                        />
                                    </div>
                                    <Fields fieldName="Email:" fieldType="email" datefield="email" user={user} setUser={setUser} />
                                    <Fields fieldName="Company Name" fieldType="text" datefield="company_name" user={user} setUser={setUser} />
                                    <Button type="button" className="text-white" loading={profileLoading} onClick={handleSubmit}>
                                        Submit
                                    </Button>
                                </div>
                            )}
                            {activeTab === "password" && (
                                <div>
                                    <form onSubmit={handlechangepassword}>
                                        <input id="username" type="email" autoComplete="username" value={user.email} readOnly hidden />
                                        <div className="my-4 flex items-center gap-4">
                                            <span className="text-sm w-20 text-text-secondary">Current Password</span>
                                            <input
                                                type="password"
                                                value={current_password}
                                                onChange={(e) => setCurrentPassword(e.target.value)}
                                                autoComplete="current-password"
                                                className="px-3 py-1 w-80 border border-border rounded text-sm focus:ring-2 focus:ring-border-focus focus:border-transparent"
                                            />
                                        </div>
                                        <div className="my-4 flex items-center gap-4">
                                            <span className="text-sm w-20 text-text-secondary">New Password</span>
                                            <input
                                                id="new-password"
                                                type="password"
                                                value={new_password}
                                                onChange={(e) => setNewPassword(e.target.value)}
                                                autoComplete="new-password"
                                                className="px-3 py-1 w-80 border border-border rounded text-sm focus:ring-2 focus:ring-border-focus focus:border-transparent"
                                            />
                                        </div>
                                        <div className="my-4 flex items-center gap-4">
                                            <span className="text-sm w-20 text-text-secondary">Confirm Password</span>
                                            <input
                                                type="text"
                                                value={confirmpassword}
                                                id="password"
                                                autoComplete="new-password"
                                                onChange={(e) => setConfirmPassword(e.target.value)}
                                                className="px-3 py-1 w-80 border border-border rounded text-sm focus:ring-2 focus:ring-border-focus focus:border-transparent"
                                            />
                                        </div>
                                        <Button type="submit" loading={passwordLoading}>
                                            Submit
                                        </Button>
                                    </form>

                                </div>
                            )}

                        </div>
                    </div>

                </div>
            </main>
            {/* modal */}

        </div>
    )
}
export default ProfileSettings
